import { render, staticRenderFns } from "./insureForm2.vue?vue&type=template&id=1896fc7a&scoped=true"
import script from "./insureForm2.vue?vue&type=script&lang=js"
export * from "./insureForm2.vue?vue&type=script&lang=js"
import style0 from "./insureForm2.vue?vue&type=style&index=0&id=1896fc7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1896fc7a",
  null
  
)

export default component.exports